<template>
	<div :class="classNames+ '_text'">
		<!-- action_type1:用户发消息;2:跳转;3:电话拨打;4:小程序; -->
		<!-- <div v-if="data.actions.text_link.action_type == 1">
			<p>{{data.title}}</p>
			<p>测试</p>
		</div> -->
		<div v-if="data.actions.text_link">
			<p>{{data.title.split('\n')[0]}}</p>
			<p>
				<a :href="data.actions.text_link.value" target="_blank">{{data.actions.text_link.name}}</a>
			</p>
		</div>
		<div v-else-if="data.actions.phone">
			<p>{{data.title.split('\n')[0]}}</p>
			<p><a href="javascript:;" :tel="data.actions.phone.phone_number">{{data.actions.phone.name}}</a></p>
		</div>
		<div v-else>
			<p>不支持的消息，请打开抖音app查看</p>
		</div>
		<!-- <div v-if="data.actions.text_link.action_type == 4">
			<p>{{data.title}}</p>
			<p>测试</p>
		</div> -->
		<!-- {{data}} -->
	</div>
</template>
<script>
	export default {
		props: {
			data: {
				type: Object,
				default: () => ({
				})
			},
		},
		data() {
			return {
				classNames: 'messageItem',
			}
		},
		methods: {
			openLink(data){
				if(data){
					window.open(data)
				}
			}
		}
	}
</script>
<style src="./chat-message.less" lang="less" scoped>
</style>
